export default __webpack_public_path__ + "static/25-206ffe0a4120254dc8aac00077f12863.webp";